import { WidgetProps } from '@rjsf/utils';
import React, { useEffect, useState } from 'react';
import { Input, Select, SelectOption, Checkbox } from '@cv/eds-react';
import Form from 'react-bootstrap/Form';
import './form.css';

export const CustomEDSInput = function (props: WidgetProps) {
  const inputOnChange = (e) => {
    props.onChange(e.target.value);
  };
  return (
    <>
      <Input
        placeholder={props.placeholder || props.name}
        onChange={inputOnChange}
        disabled={props.disabled}
        readOnly={props.readOnly}
        validation
        value={props.value || ''}
        style={{ width: '100%', margin: '5px 0 8px 0' }}
      />
    </>
  );
};

export const CustomEDSSelect1 = function (props: WidgetProps) {
  const [selectedValues, setSelectedValues] = useState(props.value || '');
  const { selectedValue1 } = selectedValues;
  const handleSelect = (state, value) => {
    setSelectedValues(
      { ...selectedValues, [state]: value },
      props.onChange(value.toString())
    );
  };
  const getOptions = () => {
    const result = [];
    let index = 1;
    const options = props.options.enumOptions;
    result.push(
      options?.map((itm, key) => {
        return (
          <SelectOption
            key={key}
            value={itm.value}
            children={<span>{itm.label}</span>}
            data={itm.value}
          />
        );
        index++;
      })
    );
    return result;
  };
  return (
    <>
      <Select
        dataType="input-single"
        value={selectedValue1 && selectedValue1[0]}
        label={'Select options'}
        onChange={(value) => handleSelect('selectedValue1', value)}
        placeholder={props.placeholder ||  props.name || "Select option"}
        style={{ maxWidth: '100%', width: '100%', margin: '5px 0 8px 0' }}
      >
        {getOptions()}
      </Select>
    </>
  );
};

export const CustomEDSSelect = function (props: WidgetProps) {
  const [selectedValues, setSelectedValues] = useState(props?.value);

  const handleSelect = (e) => {
    if (props?.multiple) {
      const options = e.target.selectedOptions;
      const value = [];
      for (let i = 0; i < options.length; i++) {
        const val = isNaN(options[i].value)
          ? options[i].value
          : parseInt(options[i].value);
        value.push(val);
      }
      setSelectedValues(value);
      props.onChange(value);
    } else {
      const val = isNaN(e.target.value) ? e.target.value : parseInt(e.target.value);
      const value = props.options.enumOptions.find((v) => {
        return v.value === val;
      });
      setSelectedValues(value.value);
      props.onChange(value.value);
    }
  };
  const getOptions = () => {
    const result = [];
    const options = props.options.enumOptions;
    result.push(
      options?.map((itm) => {
        return (
          <option key={itm.value} value={itm.value}>
            {itm.label}
          </option>
        );
      })
    );
    return result;
  };

  return (
    <Form.Control
      as="select"
      onChange={handleSelect}
      value={selectedValues}
      multiple={props?.multiple}
    >
      {getOptions()}
    </Form.Control>
  );
};

export const CustomEDSCheckbox = function (props: WidgetProps) {
  const handleChange = (_, checked) => {
    props.onChange(checked);
  };

  return <Checkbox checked={props.value} label={props.label} onChange={handleChange} />;
};
